import { Box, Divider, Stack, Typography, styled } from "@mui/material"
import React from "react"
import { SwiperSlide } from "swiper/react"

const SliderItem = styled(Box)(
    ({}) => `
        position: relative;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
    `
)


const SliderCaptionDivider = styled(Divider)(
    ({theme}) => `
        margin-right: ${theme.spacing(1.5)};
        border-color: ${theme.palette.primary.main} !important;
        border-width: 2px !important;
        border-radius: 4px !important;
    `
)

export default function SliderHomeItem({ data }) {

    return (
        <SliderItem>
            <img src={data.Src} alt={data.Alt} style={initImageStyles} />
        </SliderItem>
    )
}

const initImageStyles = {

    objectFit: "cover",
    width: "100%",
    height: "100%"
}